import Dexie from "dexie";
import * as services from "./services";
import dbInstance from "./instance";

export interface IIndexedDBService {
    instance: Dexie;
    services: typeof services;
}

const indexedDBService: IIndexedDBService = {
    instance: dbInstance,
    services,
};

export default indexedDBService;
